/**
 /**
 /**
 * Created by Alican Köker on 2018-08-03.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power1, TimelineLite, TweenLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsReels} from "../../reel/reelarea/FruitsReels";
import {FruitsHelper} from "../../utils/FruitsHelper";
import {FruitsBonusIndicator} from "./FruitsBonusIndicator";
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");

export class BonusOverlayView extends BaseView {

    private _layer:ScalableLayer;
    private _rightSideLayer:ScalableLayer;
    private _introViewLayer:ScalableLayer;
    private _stickyRespinOverlayLayer:ScalableLayer;
    private _container:PIXI.Container;
    private _frameContainer:PIXI.Container;
    private _scattersStatus:boolean[];
    private _scatters:PIXI.Sprite[];
    private _scatterAttentions:TimelineSprite[];
    private _boltAnimations:TimelineSprite[];
    private _plusOnes:PIXI.Sprite[];
    private _upgradeArrow:PIXI.Sprite;
    private _fxStars:PIXI.Sprite;
    private _plusOneTarget:[number, number];
    private _upgradeArrowTarget:[number, number];
    private _landingAnims:TimelineSprite[];
    private _scatterFrames:PIXI.Sprite[];
    private _scatterFrameAnims:TimelineSprite[];
    private _scatterFrameAnimState:boolean[];
    private _landingTimeline:TimelineLite;
    private _initialPaytable:number[];
    private _initialIndex:number;
    private _indicatorCellHeight:number;
    private _visualsInitialised:boolean = false;
    private _scatterContainer:PIXI.Container;
    private _scatterBoltImages:PIXI.Sprite[];
    private _restored:boolean = false;
    private _reelGloss:TimelineSprite;

    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _indicator:FruitsBonusIndicator;
    private _customEase:CustomEase;

    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BONUS_OVERLAY.name);
        this._rightSideLayer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BONUS_RIGHT_SIDE_OVERLAY.name);
        this._introViewLayer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BONUS_GAME_PRE_INTRO_SCATTERS.name);
        this._stickyRespinOverlayLayer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.STICKY_RESPIN_OVERLAY.name);
        this._container = new PIXI.Container();
        this._frameContainer = new PIXI.Container();
        this._boltAnimations = [];
        this._scattersStatus = [];
        this._scatters = [];
        this._scatterAttentions = [];
        this._scatterFrames = [];
        this._scatterFrameAnims = [];
        this._scatterFrameAnimState = [];
        this._scatterBoltImages = [];
        this._scatterContainer = new PIXI.Container();
        this._layer.addChild(this._container);
        this._layer.addChild(this._scatterContainer);
        this._stickyRespinOverlayLayer.addChild(this._frameContainer);

        this._landingTimeline = new TimelineLite();

        for(let i:number = 0; i < 16; i++) {
            this._scattersStatus.push(false);
            this._scatterFrameAnimState.push(false);
        }

        this._customEase = CustomEase.create("custom", "M0,0 C0,0 0.32,1.588 0.448,1.588 0.568,1.588 0.596,0.862 0.776,0.89 0.868,0.904 1,1 1,1");
    }

    protected onResize(resizeData:IResizeData):void {
        EventHandler.dispatchEvent(new GameEvent(FruitsReels.SET_ORIENTATION, resizeData.orientation));

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._orientation = Orientation.PORTRAIT;
            this._indicator.position.set(940, -160);
            this._indicator.scale.set(1.2);

            this._upgradeArrowTarget = [915, -120];
            this._indicatorCellHeight = 88;

            this._plusOneTarget = [640, 900];
        } else {
            this._orientation = Orientation.LANDSCAPE;
            this._indicator.position.set(1200, 55);
            this._indicator.scale.set(.65);

            this._upgradeArrowTarget = [1200, 50];
            this._indicatorCellHeight = 88 * .65;

            this._plusOneTarget = [1150, 490];
        }

        if(this._visualsInitialised) {
            this.repositionVisualObjects();
        }
    }

    protected initAnimations():void {
        this.initiateVisualObjects();
        this._indicator.visible = false;
    }

    public stickScatter(reelId:number, restored:boolean = false):void {
        if(!this._scatters[reelId].visible) {
            if(!restored) {
                this._landingTimeline.add(() => {
                    this._scatters[reelId].visible = false;
                    this._scattersStatus[reelId] = true;
                    this._landingAnims[reelId].visible = true;
                    this._landingAnims[reelId].playLoop();
                });
                this._landingTimeline.add(() => {
                    this._landingAnims[reelId].visible = false;
                    this._landingAnims[reelId].stopLoop();
                    this._scatters[reelId].visible = true;
                }, this._landingAnims[reelId].totalDuration);
                this._landingTimeline.play();
            } else {
                this._landingAnims[reelId].visible = false;
                this._landingAnims[reelId].stopLoop();
                this._scatters[reelId].visible = true;
                this._scattersStatus[reelId] = true;
            }
        }
    }

    public resetScatterOverlay():void {
        if(this._landingTimeline)
            this._landingTimeline.kill();

        this._landingTimeline = new TimelineLite();

        this.setScatterLevel(1);

        for(let i:number = 0; i < 16; i++) {
            this._scatters[i].visible = false;
            this._scatterAttentions[i].visible = false;
            this._scattersStatus[i] = false;
            this._boltAnimations[i].visible = false;
        }
        this._indicator.visible = false;
    }

    public resetIndicator():void {
        if(!this._restored)
            this._indicator.reset();
    }

    private repositionVisualObjects():void {

        if(this._orientation === Orientation.LANDSCAPE) {
            this._reelGloss.position.set(953, 336);
        } else {
            this._reelGloss.position.set(564, 725);
        }


        for(let i = 0; i < 16; i++) {
            let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(i);
            let scatterOverlayObjectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation, FruitsGameMode.BONUS_GAME);
            let bonusFramePositions:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation, FruitsGameMode.NORMAL);

            let scatter:PIXI.Sprite = (<PIXI.Sprite>this._scatters[i]);
            let landingAnim:TimelineSprite = this._landingAnims[i];

            let scatterAttentionAnim:TimelineSprite = this._scatterAttentions[i];
            let scatterFrame:PIXI.Sprite = this._scatterFrames[i];
            let scatterFrameAnim:TimelineSprite = this._scatterFrameAnims[i];
            let boltAnim:TimelineSprite = this._boltAnimations[i];
            let scatterBoltImage = this._scatterBoltImages[i];

            if(this._scattersStatus[i]) {
                scatterFrameAnim.stopLoop();
                scatterFrameAnim.position.set(bonusFramePositions[0], bonusFramePositions[1]);
                scatterFrameAnim.playLoop();
            }

            if(this._orientation === Orientation.LANDSCAPE) {
                scatter.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 2, scatterOverlayObjectPos[1] - scatter.height / 2 - 1);
                scatterFrame.position.set(bonusFramePositions[0] - scatterFrame.width / 2, bonusFramePositions[1] - scatterFrame.height / 2);
                boltAnim.position.set(scatterOverlayObjectPos[0], scatterOverlayObjectPos[1]);
                scatterBoltImage.position.set(scatterOverlayObjectPos[0], scatterOverlayObjectPos[1]);
                landingAnim.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 18, scatterOverlayObjectPos[1] - scatter.height / 2 - 14);

                this.stopAttention(i);
                scatterAttentionAnim.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 18, scatterOverlayObjectPos[1] - scatter.height / 2 - 17);
            } else {
                if(i > 3) {
                    scatter.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 4, scatterOverlayObjectPos[1] - scatter.height / 2 - 4);
                    landingAnim.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 5 - 16, scatterOverlayObjectPos[1] - scatter.height / 2 - 18);
                } else {
                    scatter.position.set(scatterOverlayObjectPos[0] - scatter.width / 2, scatterOverlayObjectPos[1] - scatter.height / 2 + 1);
                    landingAnim.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 5 - 16, scatterOverlayObjectPos[1] - scatter.height / 2 - 3 - 13);
                }

                scatterFrame.position.set(bonusFramePositions[0] - scatterFrame.width / 2 - 7, bonusFramePositions[1] - scatterFrame.height / 2 - 5);
                boltAnim.position.set(scatterOverlayObjectPos[0], scatterOverlayObjectPos[1]);
                scatterBoltImage.position.set(scatterOverlayObjectPos[0], scatterOverlayObjectPos[1]);

                this.stopAttention(i);
                if(i > 3)
                    scatterAttentionAnim.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 21, scatterOverlayObjectPos[1] - scatter.height / 2 - 19);
                else
                    scatterAttentionAnim.position.set(scatterOverlayObjectPos[0] - scatter.width / 2 - 8 - 12, scatterOverlayObjectPos[1] - scatter.height / 2 - 3 - 12);
            }
        }
    }

    public initiateVisualObjects():void {
        this._container.removeChildren();

        this.setIndicatorInitVals();

        if(!this._indicator) this.initIndicator();
        else
            this._indicator.setIndicator(this._initialPaytable, this._initialIndex);

        this._container.addChild(this._indicator);

        this.initFrames();

        this.initRightSideOverlay();

        this.initReelGloss();

        this.setScatterLevel(this._indicator._currentIndex);

        this._visualsInitialised = true;
    }


    /**   Scatter Frames for the case when both features are triggered   */
    private initFrames():void {

        this._scatterFrames = [];
        this._scatterFrameAnims = [];

        let scatterFrame:PIXI.Sprite;
        let scatterFrameAnim:TimelineSprite;


        for(let i = 0; i < 16; i++) {
            let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(i);
            let bonusFramePositions:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation, FruitsGameMode.NORMAL);


            scatterFrame = new PIXI.Sprite(GameResources.getTextures("scatterFrame")[0]);
            scatterFrame.visible = this._scatterFrameAnimState[i];
            scatterFrame.pivot.set(.5, .5);
            scatterFrame.scale.set(.95, .95);
            this._scatterFrames.push(scatterFrame);

            scatterFrameAnim = new TimelineSprite(GameResources.getTextures("scatterFrameAnim"));
            scatterFrameAnim.stopLoop();
            scatterFrameAnim.visible = this._scatterFrameAnimState[i];
            scatterFrameAnim.blendMode = PIXI.BLEND_MODES.ADD;
            scatterFrameAnim.scale.set(1.9);
            scatterFrameAnim.anchor.set(.5, .5);

            this._scatterFrameAnims.push(scatterFrameAnim);
            scatterFrameAnim.position.set(bonusFramePositions[0], bonusFramePositions[1]);

            this._frameContainer.addChild(scatterFrame);
            this._frameContainer.addChild(scatterFrameAnim);
        }

    }

    private initReelGloss():void {
        this._reelGloss = new TimelineSprite(GameResources.getTextures("bonusReelGloss"));
        this._reelGloss.anchor.set(.5, .5);
        this._reelGloss.scale.set(2);
        this._reelGloss.blendMode = PIXI.BLEND_MODES.ADD;
        this._reelGloss.hide();

        this._container.addChild(this._reelGloss);
    }

    public playReelGlossAnimaiton():void {
        this._reelGloss.getAnimationAutoShowHide(true, true);
    }

    public activateScatterFrame(reelId:number):void {
        this._scatterFrames[reelId].visible = true;
        this._scatterFrameAnimState[reelId] = true;
        this._scatterFrameAnims[reelId].visible = true;
        this._scatterFrameAnims[reelId].playLoop();
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._scatterFrameAnims[reelId].stopLoop();
            this._scatterFrameAnims[reelId].visible = false;
        }, .5);
    }

    public deactivateScatterFrame(reelId:number):void {
        this._scatterFrames[reelId].visible = false;
        this._scatterFrameAnimState[reelId] = false;
        this._scatterFrameAnims[reelId].visible = false;
    }

    public resetScatterFrames():void {
        for(let i:number = 0; i < 16; i++)
            this.deactivateScatterFrame(i);
    }

    /**   Reloads Sprites according to the current bonus level, repositions everything   */
    public setScatterLevel(currentIndicatorIndex:number):void {
        this._scatters = [];
        this._scatterAttentions = [];
        this._landingAnims = [];
        this._boltAnimations = [];
        this._scatterBoltImages = [];

        this._scatterContainer.removeChildren();
        for(let i:number = 0; i < FruitsGameConfig.instance.REELS_NUM; i++) {
            if(currentIndicatorIndex > -1 && currentIndicatorIndex < 3) {
                this._scatters[i] = new PIXI.Sprite(GameResources.getTextures("S/S")[0]);
                this._scatterAttentions[i] = new TimelineSprite(GameResources.getTextures("scatterAttentionAnim_A"));
                this._landingAnims[i] = new TimelineSprite(GameResources.getTextures("S_win"));
            } else if(currentIndicatorIndex > 2 && currentIndicatorIndex < 6) {
                this._scatters[i] = new PIXI.Sprite(GameResources.getTextures("scatterB")[0]);
                this._scatterAttentions[i] = new TimelineSprite(GameResources.getTextures("scatterAttentionAnim_B"));
                this._landingAnims[i] = new TimelineSprite(GameResources.getTextures("S_B_win"));
            } else if(currentIndicatorIndex > 5 && currentIndicatorIndex < 8) {
                this._scatters[i] = new PIXI.Sprite(GameResources.getTextures("scatterC")[0]);
                this._scatterAttentions[i] = new TimelineSprite(GameResources.getTextures("scatterAttentionAnim_C"));
                this._landingAnims[i] = new TimelineSprite(GameResources.getTextures("S_C_win"));
            } else {
                this._scatters[i] = new PIXI.Sprite(GameResources.getTextures("scatterD")[0]);
                this._scatterAttentions[i] = new TimelineSprite(GameResources.getTextures("scatterAttentionAnim_D"));
                this._landingAnims[i] = new TimelineSprite(GameResources.getTextures("S_D_win"));
            }

            this._boltAnimations[i] = new TimelineSprite(GameResources.getTextures("scatterBoltAnimation"));
            this._boltAnimations[i].stopLoop();
            this._boltAnimations[i].visible = this._scattersStatus[i];
            this._boltAnimations[i].anchor.set(.5);


            this._scatters[i].visible = this._scattersStatus[i];
            this._scatterAttentions[i].visible = this._scattersStatus[i];
            this._scatterAttentions[i].stopLoop();
            this._landingAnims[i].visible = this._scattersStatus[i];
            this._landingAnims[i].stopLoop();

            this._scatterContainer.addChild(this._scatters[i]);
            this._scatterContainer.addChild(this._scatterAttentions[i]);
            this._scatterContainer.addChild(this._landingAnims[i]);
            this._scatterContainer.addChild(this._boltAnimations[i]);
        }

        for(let i:number = 0; i < FruitsGameConfig.instance.REELS_NUM; i++) {
            this._scatterBoltImages[i] = new PIXI.Sprite(GameResources.getTextures("scatterBoltAnimation")[0]);
            this._scatterBoltImages[i].visible = false;
            this._scatterBoltImages[i].alpha = 0;
            this._scatterBoltImages[i].anchor.set(.5);
            this.setBoltSize(this._boltAnimations[i]);
            this._scatterContainer.addChild(this._scatterBoltImages[i]);
        }

        this.repositionVisualObjects();
    }

    private setBoltSize(object:TimelineSprite | PIXI.Sprite):number {
        let level:number = FruitsHelper.determineIndicatorLevel(this._indicator._currentIndex);
        switch(level) {
            case 1:
                object.scale.set(.62);
                return .62;
            case 2:
                object.scale.set(.75);
                return .75;
            case 3:
                object.scale.set(.88);
                return .88;
            case 4:
                object.scale.set(1);
                return 1;
            default:
                object.scale.set(.62);
                return .62;
        }
    }

    public playBoltMotion(reelIndex:number):void {

        let tl:TimelineLite = new TimelineLite();

        let objectToAnimate:PIXI.Sprite = this._scatterBoltImages[reelIndex];

        let boltSize:number = this.setBoltSize(objectToAnimate);

        let target:[number, number] = this._upgradeArrowTarget;

        this.setBoltSize(objectToAnimate);


        tl.add([
            () => objectToAnimate.visible = true,
            () => objectToAnimate.alpha = 1,
        ]);

        tl.add(TweenLite.to(objectToAnimate.scale, 0.25, {
            x : boltSize * 1.5,
            y : boltSize * 1.5,
            ease : this._customEase
        }));

        tl.add([
            TweenLite.to(objectToAnimate, 0.45, {
                x : target[0] + 20,
                y : target[1] + (10 - this._indicator._currentIndex) * this._indicatorCellHeight,
                ease : Power1.easeIn
            }),
            TweenLite.to(objectToAnimate.scale, 0.45, {
                x : boltSize,
                y : boltSize,
                ease : Power1.easeIn
            }),
        ], "+=0.2");

        tl.add([
            () => objectToAnimate.visible = false,
            () => objectToAnimate.alpha = 0,
        ]);
    }

    /**   Right Side Animations (2x2 Area)   */
    private initRightSideOverlay():void {
        this._plusOnes = [];
        for(let i:number = 0; i < 4; i++) {
            this._plusOnes.push(new PIXI.Sprite(GameResources.getTextures("B1_Element")[0]));
            this._plusOnes[i].anchor.set(.5, .5);
            this._plusOnes[i].visible = false;
        }
        this._upgradeArrow = new PIXI.Sprite(GameResources.getTextures("B2_Element")[0]);
        this._fxStars = new PIXI.Sprite(GameResources.getTextures("FX_Stars")[0]);

        this._upgradeArrow.anchor.set(.5, .5);
        this._fxStars.anchor.set(.5, .5);

        this._upgradeArrow.visible = false;
        this._fxStars.visible = false;

        this._plusOnes.forEach((plusOne) => {this._rightSideLayer.addChild(plusOne);});
        this._rightSideLayer.addChild(this._upgradeArrow);
        this._rightSideLayer.addChild(this._fxStars);
    }

    public playBonusAnim(reelIndex:number, symbol:string):void {
        let tl:TimelineLite = new TimelineLite();

        let objectToAnimate:PIXI.Sprite = symbol === "B1" ? this._plusOnes[reelIndex - 12] : this._upgradeArrow;

        let reelIndexes:[number, number] = [Math.floor((reelIndex - 12) / 2), (reelIndex - 12) % 2 + 1];
        let scatterOverlayObjectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation, "BONUS_GAME");

        let target:[number, number] = symbol === "B1" ? this._plusOneTarget : this._upgradeArrowTarget;

        objectToAnimate.position.set(scatterOverlayObjectPos[0], scatterOverlayObjectPos[1]);
        objectToAnimate.visible = true;
        objectToAnimate.alpha = 0;

        this._fxStars.visible = true;
        this._fxStars.alpha = 0;
        this._fxStars.position.set(scatterOverlayObjectPos[0], scatterOverlayObjectPos[1]);

        if(symbol === "B1") {
            this.playPlusOneMotion(objectToAnimate, scatterOverlayObjectPos, tl, target);
            SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_METER_UP);
        } else {
            this.playUpgradeMotion(objectToAnimate, scatterOverlayObjectPos, tl, target);
            SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_METER_UP);
        }

        tl.play();
    }

    private playPlusOneMotion(objectToAnimate:PIXI.Sprite, scatterOverlayObjectPos:number[], tl:TimelineLite, target:[number, number]):void {
        tl.add(() => {
            TweenLite.to(objectToAnimate, .05, {alpha : 1});
            TweenLite.to(this._fxStars, .05, {alpha : .8});
        });

        tl.add(() => {
            TweenLite.to(objectToAnimate, .6, {
                x : scatterOverlayObjectPos[0],
                y : scatterOverlayObjectPos[1] - 80
            });
            TweenLite.fromTo(this._fxStars.scale, .6, {x : 0, y : 0}, {x : 1, y : 1});
        }, .05);

        tl.add(() => {
            TweenLite.to(this._fxStars, .25, {alpha : 0});
        }, .45);


        tl.add(() => {
            TweenLite.to(objectToAnimate, .2, {x : target[0], y : target[1]});
            SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_SWEEP);
        }, .65);

        tl.add(() => {
            TweenLite.to(this._fxStars, .05, {alpha : .8});
            this._fxStars.position.set(target[0], target[1]);
            TweenLite.fromTo(this._fxStars.scale, .6, {x : 0, y : 0}, {x : 1, y : 1});
        }, .70);

        tl.add(() => {
            TweenLite.to(objectToAnimate, .05, {alpha : 0});
        }, .85);

        tl.add(() => {
            TweenLite.to(objectToAnimate, 0, {visible : false});
        }, .9);

        tl.add(() => {
            TweenLite.to(this._fxStars, .4, {alpha : 0});
        }, 1.1);
    }

    private playUpgradeMotion(objectToAnimate:PIXI.Sprite, scatterOverlayObjectPos:number[], tl:TimelineLite, target:[number, number]):void {
        tl.add(() => {
            TweenLite.to(objectToAnimate, .05, {alpha : 1});
            TweenLite.to(this._fxStars, .05, {alpha : .8});
        });

        tl.add(() => {
            TweenLite.to(objectToAnimate, .6, {
                x : scatterOverlayObjectPos[0],
                y : scatterOverlayObjectPos[1] - 80
            });
            TweenLite.fromTo(this._fxStars.scale, .8, {x : 0, y : 0}, {x : 1, y : 1});
        }, .05);

        tl.add(() => {
            TweenLite.to(this._fxStars, .2, {alpha : 0});
        }, .25);

        tl.add(() => {
            TweenLite.to(objectToAnimate, .2, {
                x : target[0] + 20,
                y : target[1] + 10 * this._indicatorCellHeight
            });
            SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_SWEEP);
        }, .65);

        tl.add(() => {
            TweenLite.to(objectToAnimate, .05, {alpha : 0});
        }, .85);

        tl.add(() => {
            TweenLite.to(objectToAnimate, 0, {visible : false});
        }, .9);
    }

    /**   Attentions   */
    public playAttention(index:number):void {
        if(this._scattersStatus[index]) {
            this._scatters[index].visible = false;
            this._scatterAttentions[index].visible = true;
            this._scatterAttentions[index].playLoop();
            this._boltAnimations[index].visible = true;
            this._boltAnimations[index].playLoop();
            this._landingAnims[index].visible = false;
        }
    }

    public stopAttention(index:number):void {
        if(this._scattersStatus[index]) {
            this._scatterAttentions[index].stopLoop();
            this._scatterAttentions[index].visible = false;
            this._boltAnimations[index].stopLoop();
            this._boltAnimations[index].setFrame(0);
            this._boltAnimations[index].visible = false;
            this._scatters[index].visible = true;
            this._landingAnims[index].visible = false;
        }
    }

    public stopAttentions():void {
        for(let i:number = 0; i < 16; i++) {
            this.stopAttention(i);
        }
    }

    /**   Indicator   */
    public setIndicatorInitVals(paytable:number[] = [5, 6, 7, 8, 9, 10, 15, 25, 50, 100], index:number = 0):void {
        this._initialIndex = index;
        this._initialPaytable = paytable;
    }

    public showIndicatorOnScreenView():void {
        this._indicator.visible = true;
        this._introViewLayer.addChild(this._indicator);
    }

    public initIndicator():void {
        if(!this._indicator) this._indicator = new FruitsBonusIndicator();
        this._indicator._currentIndex = this._initialIndex;
        this._introViewLayer.removeChild(this._indicator);
        this._indicator.visible = true;
        this._introViewLayer.addChild(this._indicator);
        this._indicator.setIndicator(this._initialPaytable, this._initialIndex);
    }

    public removeIndicatorFromIntro():void {
        this._introViewLayer.removeChild(this._indicator);
        this._layer.addChild(this._indicator);
    }

    public updateMultiplier(newValues?:boolean, updateIndex?:boolean):void {
        if(updateIndex) {
            this._indicator._currentIndex++;
        }
        this._indicator.update(newValues, updateIndex);
    }

    public setIndicator(values:number[], index:number):void {
        this._indicator.setIndicator(values, index);
    }

    public initScatters(scatterPositions:boolean[]):void {
        for(let i:number = 0; i < scatterPositions.length; i++) {
            if(scatterPositions[i]) {
                this.showScatter(i + 4);
            }
        }
    }

    /** TO-DO ALİCAN*/
    public showScatter(reelId:number):void {
        this._landingAnims[reelId].visible = false;
        this._landingAnims[reelId].stopLoop();
        this._scattersStatus[reelId] = true;
        this._scatters[reelId].visible = true;
    }


    public updateScatterColor(scattersBefore:number, scattersAfter:number):void {
        let oldLevel:number = FruitsHelper.determineIndicatorLevel(scattersBefore - 3);
        let newLevel:number = FruitsHelper.determineIndicatorLevel(scattersAfter - 3);

        if(newLevel > oldLevel) {
            this.setScatterLevel(scattersAfter - 3);
        }
    }

    public restoreBonus(scatterPositions:boolean[][], currentIndex:number, indicatorValues:number[]):void {
        let rInd:number = 0;
        let sInd:number = 0;
        scatterPositions.forEach((reel) => {
            reel.forEach((pos) => {
                if(pos)
                    this.stickScatter(rInd * 3 + 4 + sInd, true);
                sInd++;
            });
            rInd++;
            sInd = 0;
        });

        this.initiateVisualObjects();
        this.setIndicator(indicatorValues, currentIndex);
        this._indicator.visible = true;
        this.setScatterLevel(currentIndex);
    }

    public set restored(val:boolean) {
        this._restored = val;
    }

    public get restored():boolean {
        return this._restored;
    }

    public startIndicator():void {
        this.initIndicator();
        this.removeIndicatorFromIntro();
    }
}